import type { Side, Square, StructureName } from "src/api";

import type { World } from "../../../../render/world/World";
import { WorldObject } from "../../../../render/world/WorldObject";
import type { BoardUpdate } from "../../updates/BoardUpdate";
import type { BoardWorldObject } from "../../updates/BoardWorldObject";
import { Structure } from "./Structure";

export class BoardStructures extends WorldObject implements BoardWorldObject {
  private readonly structureBySquare = new Map<Square, Structure>();
  private readonly world: World;

  constructor(world: World) {
    super();

    this.world = world;
  }

  onBoardUpdate(boardUpdate: BoardUpdate) {
    const seenSquares = new Set<Square>();
    for (const squareFacts of boardUpdate.facts.squares.values()) {
      const structureFacts = squareFacts.structure;
      if (!structureFacts) continue;

      const square = squareFacts.square;
      seenSquares.add(square);
      const existing = this.structureBySquare.get(square);
      if (existing?.kind === structureFacts.kind && existing.owner === structureFacts.owner) continue;

      if (existing) this.despawn(square, existing);
      this.spawn(structureFacts.kind, structureFacts.owner, square);
    }

    for (const [square, structure] of [...this.structureBySquare]) {
      if (!seenSquares.has(square)) this.despawn(square, structure);
    }
  }

  isBoardUpdateFinished() {
    return true;
  }

  dispose() {
    for (const [square, structure] of [...this.structureBySquare]) this.despawn(square, structure);
  }

  private spawn(kind: StructureName, owner: Side, square: Square) {
    const structure = new Structure(kind, owner, square);
    this.world.add(structure);
    this.structureBySquare.set(square, structure);
  }

  private despawn(square: Square, structure: Structure) {
    this.world.removeAndDispose(structure);
    this.structureBySquare.delete(square);
  }
}
